import rModelsBase from './rModelsBase';

export default class rValue<T extends rModelsBase> {
  constructor() {}
  
  public Value: T | undefined;
  public Error: boolean | undefined;
  public MessageCode: string | undefined;
  public MessageTitle: string | undefined;
  public Message: string | undefined;
}
